import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtml } from '@angular/platform-browser';

import { SvgCacheService } from '../../services/svg-cache.service';

import { Subject, takeUntil } from 'rxjs';

import { ISvgConfig } from '../../interfaces/svg.interfaces';
import { ESvgTypes } from '../../enums/svg.enums';

@Component({
  selector: 'stxt-svg-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './svg-icon.component.html',
  styleUrl: './svg-icon.component.scss'
})
export class SvgIconComponent implements OnChanges, OnDestroy {
  @Input() public iconConfig: ISvgConfig;
  @Input() public disabled?: boolean;
  public readonly ESvgTypes = ESvgTypes;
  public svgIcon: SafeHtml | undefined;
  private readonly destroy$ = new Subject<void>();

  constructor(private svgCacheService: SvgCacheService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['iconConfig']) {
      this.loadSvgIcon();
    }
  }

  private loadSvgIcon(): void {
    if (!this.iconConfig?.name) {
      this.svgIcon = undefined;
      return;
    }
    this.svgCacheService
      .getIcon(this.iconConfig.name)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: value => {
          this.svgIcon = value;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
